// @ts-nocheck
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import React from 'react';
import { isMobile } from 'react-device-detect';
import ReactGA from 'react-ga';
import { Link } from 'react-router-dom';
import Page from '../../components/library/Page';
import MessageDialog from '../../components/MessageDialog';
import ConstantValues from '../../constants/ConstantValues';
import CreateStickerDialog from './CreateStickerDialog';
import MobileDetected from './MobileDetected';
import Statistics from './Statistics';
import PageHeader from './PageHeader';
import { withTranslation  } from 'react-i18next';
import {
  MAXIMUM_IMAGE_NUMBER
} from '../../constants';
import {
  // PRIVACY
  STICKERGUIDE,
  IMAGEFORMATS
} from '../../constants/routes';


class CreateSticker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      stickerTitle: '',
      stickerAuthor: '',
      termsAgreed: false,
      openCreateStickerDialog: false,
      mobileDetected: false,
      selectedImages: [], // array of images selected,
      webpImages: [], // array of images converted
      showImageCountError: false,
      imageErrorMessage: '',
      imageIsProcessing: false,
      debugUseBase64: false,
      showMessageDialog: false,
      messageTitle: '',
      messageContent: '',
      buttonTitle: '',
    };
    this.inputRef = React.createRef();
    
  }

  componentDidMount() {
    console.log(process.env);
    if(isMobile) this.setState({mobileDetected: true});
    this.inputRef.current.addEventListener('change', this.fileSelectorChanged);
    if (document.location.hostname === ConstantValues.SiteHostname) { 
      ReactGA.pageview(window.location.pathname);
    }
  }

  handleAgreeTerms = (event) => {
    this.setState({termsAgreed: event.target.checked});
  };

  handleClose = () => {
    this.setState({openCreateStickerDialog: false});
  };

  handleCloseMobileDetected = () => {
    this.setState({mobileDetected: false});
  };

  handleCloseImageExceededDialog = () => {
    this.setState({showMessageDialog: false});
  };

  startCreateSticker = async () => {
    console.log('startCreateSticker');
    const imageLength = this.state.selectedImages.length;
    console.log(imageLength);
    var useBase64 = true;
    // Check if user has selected a valid number of images
    if(imageLength < 1){
      console.log('no image selected');
      this.setState({
        showImageCountError: true,
        imageErrorMessage: 'Please select image!'
      });
      return;
    } else if (imageLength > MAXIMUM_IMAGE_NUMBER) {
      console.log(`size exceeded ${MAXIMUM_IMAGE_NUMBER}`);
      this.setState({
        showImageCountError: true,
        imageErrorMessage: `Image limit exceeded, please limit your images to ${MAXIMUM_IMAGE_NUMBER} images.`
      });
      return;
    }

    // open dialog
    console.log('open dialog');
    this.setState({openCreateStickerDialog: true, debugUseBase64: useBase64});
    
    if (document.location.hostname === ConstantValues.SiteHostname) { 
      ReactGA.event({
        category: this.props.t('menu_item_create_stickers'),
        action: 'click'
      });
    }
  };

  saveSelectedImages = async (event) => {
    console.log('saveSelectedImages');
    const selectedImages = event.target.files;
    console.log(selectedImages);
    // validate image quantity 
    if(selectedImages > MAXIMUM_IMAGE_NUMBER){
      console.log('size exceeded');
      this.setState({showMessageDialog: true, messageTitle: 'Images exceed limit', messageContent: `Maximum ${MAXIMUM_IMAGE_NUMBER} images are allowed, please limit your images.`, buttonTitle: 'OK'});
      document.getElementById('stickerImageInput').value = '';
      return;
    }
    
    this.setState({selectedImages: selectedImages, showImageCountError: false});
  };


  render() {
    const { t } = this.props;

    const ImageError = () => {           
      if (this.state.showImageCountError) {
        return (
          <Typography variant='subtitle2' color='error' component='div'>
            {t('text_image_selected_error')}
          </Typography>
        );
      }
      return null;
    };

    return (
      <>
        <MessageDialog
          open={this.state.showMessageDialog}
          onClose={this.handleCloseImageExceededDialog}
          dialogTitle={this.state.messageTitle}
          dialogContent={this.state.messageContent}
          buttonTitle={this.state.buttonTitle}
        />
        <MobileDetected
          open={this.state.mobileDetected}
          onClose={this.handleCloseMobileDetected}
        />
        {this.state.openCreateStickerDialog && (
          <CreateStickerDialog
            open={this.state.openCreateStickerDialog}
            onClose={this.handleClose}
            stickerAuthor={this.state.stickerAuthor}
            stickerTitle={this.state.stickerTitle}
            stickerImages={this.state.selectedImages}
            debugUseBase64={this.state.debugUseBase64}
          />
        )}
        <Page>
          <Grid container padding={0} spacing={2}>
            <PageHeader/>
            {/* Main sticker creation form */}
            <Grid xs={12} item>
              <TextField 
                label={`${t('text_field_title')} (${t('text_optional')})`}
                variant='outlined'
                color='themeColor'
                fullWidth
                onChange={(event) => this.setState({stickerAuthor: event.target.value})}
              />
            </Grid>
            <Grid xs={12} item style={{justifyContent: 'left', alignItems: 'center', display: 'flex'}}>
              <Button
                onClick={() => {this.inputRef.current.click();}}
                color='themeColor'
                variant='outlined'
              >
                {t('text_select_images')}
              </Button>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Typography variant='subtitle2' color='gray' component='div' style={{marginLeft: 10}}>
                  {t('text_image_selected')}: {this.state.selectedImages.length} / {MAXIMUM_IMAGE_NUMBER} ({t('text_maximum')})
                </Typography>
              </div>
              <input 
                type='file' name='image_file' className='custom-file-input' id='stickerImageInput' multiple 
                accept='image/png, image/jpeg, image/webp, image/gif'
                style={{display:'none'}}
                onChange={this.saveSelectedImages}
                ref={this.inputRef}
                onClick={(event)=> { event.currentTarget.value = null; }}
              />
            </Grid>
            <Grid xs={12} item>
              <Typography variant='subtitle2' color='gray' component='div'>
                {t('text_supported_format')}: PNG, JPG/JPEG, WEBP, GIF
              </Typography>
              <ImageError />
              {/* <Typography variant='subtitle2' color='gray' component='div'>
                {t('text_terms_and_conditions_2')} <a href={PRIVACY.link}>{t('text_terms_and_conditions')}</a>.
              </Typography> */}
              <Button
                variant='contained' 
                fullWidth
                onClick={this.startCreateSticker}
                id='createSticker-react'
                color='themeColor'
              >
                <Typography variant='subtitle2' color='white' component='div'>
                  {t('text_create_sticker')}
                </Typography>
              </Button>
            </Grid>
            {/* Move educational card here, after sticker creation and before statistics */}
            <Grid xs={12} item>
              <Paper elevation={3} style={{padding: '30px', margin: '0 0 30px 0', background: '#f8f9fa'}}>
                <Typography variant="h6" gutterBottom style={{color: '#1976d2', marginBottom: '15px'}}>
                  {t('text_educational_title')}
                </Typography>
                <Typography variant="body1" gutterBottom style={{marginBottom: '15px'}}>
                  {t('text_educational_description')}
                </Typography>
                {/* <div className="buymecoffee-button" style={{margin: '0.2rem 0 0.5rem 0'}}>
                  <a href="https://www.buymeacoffee.com/nwdstudio" target="_blank" rel="noopener noreferrer">
                    <img 
                      src="https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png" 
                      alt="Buy Me A Coffee" 
                      style={{
                        display: 'block', 
                        margin: '0 auto 10px', 
                        boxShadow: 'none', 
                        border: 'none', 
                        background: 'none',
                        height: '56px',
                        maxWidth: '220px',
                        minWidth: '120px',
                        width: 'auto'
                      }} 
                    />
                  </a>
                </div> */}
                <Divider style={{margin: '20px 0'}} />
                <Typography variant="h6" gutterBottom style={{color: '#495057', marginBottom: '15px'}}>
                  {t('text_quick_tips_title')}
                </Typography>
                <ul style={{margin: '10px 0', paddingLeft: '20px'}}>
                  <li><Typography variant="body2">{t('text_tip_1')}</Typography></li>
                  <li><Typography variant="body2">{t('text_tip_2')}</Typography></li>
                  <li><Typography variant="body2">{t('text_tip_3')}</Typography></li>
                  <li><Typography variant="body2">{t('text_tip_4')}</Typography></li>
                </ul>
              </Paper>
            </Grid>
            
            {/* About Signal card */}
            <Grid xs={12} item>
              <Paper elevation={3} style={{ padding: '30px', margin: '0 0 30px 0', background: '#f0f7ff' }}>
                <Typography variant="h6" gutterBottom style={{ color: '#1976d2', marginBottom: '15px' }}>
                  {this.props.t('text_about_signal_title')}
                </Typography>
                <Typography variant="body1" gutterBottom style={{ marginBottom: '15px' }}>
                  {this.props.t('text_about_signal_description')}
                </Typography>
              </Paper>
            </Grid>

            {/* Guide cards section */}
            <Grid xs={12} item>
              <div style={{maxWidth: '700px', margin: '0 auto 30px auto'}}>
                <Grid container spacing={3} style={{ justifyContent: 'center', display: 'flex' }}>
                  <Grid item xs={12} md={6} style={{display: 'flex', justifyContent: 'center'}}>
                    <Paper elevation={3} style={{padding: '30px', maxWidth: '350px', width: '100%', background: '#fff8e1', margin: '0', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                      <Typography variant="h6" gutterBottom style={{color: '#f57c00', marginBottom: '15px', textAlign: 'center'}}>
                        {t('text_sticker_guide_card_title')}
                      </Typography>
                      <Typography variant="body2" gutterBottom style={{marginBottom: '15px', textAlign: 'center'}}>
                        {t('text_sticker_guide_card_description')}
                      </Typography>
                      <Button 
                        component={Link}
                        to={`/${this.props.i18n?.language || 'en'}/${STICKERGUIDE.link}`}
                        variant="outlined" 
                        color="primary"
                        style={{marginTop: 'auto', color: 'black'}}
                      >
                        {t('text_learn_more')}
                      </Button>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} md={6} style={{ display: 'flex', justifyContent: 'center' }}>
                    <Paper elevation={3} style={{ padding: '30px', maxWidth: '350px', width: '100%', background: '#f3e5f5', margin: '0', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <Typography variant="h6" gutterBottom style={{ color: '#7b1fa2', marginBottom: '15px', textAlign: 'center' }}>
                        {this.props.t('text_image_formats_card_title')}
                      </Typography>
                      <Typography variant="body2" gutterBottom style={{marginBottom: '15px', textAlign: 'center'}}>
                        {t('text_image_formats_card_description')}
                      </Typography>
                      <Button 
                        component={Link}
                        to={`/${this.props.i18n?.language || 'en'}/${IMAGEFORMATS.link}`}
                        variant="outlined" 
                        color="primary"
                        style={{marginTop: 'auto', color: 'black'}}
                      >
                        {t('text_learn_more')}
                      </Button>
                    </Paper>
                  </Grid>
                </Grid>
              </div>
            </Grid>
            
            {/* Statistics card */}
            <Grid xs={12} item>
              <Paper elevation={3} style={{ padding: '30px', margin: '0', background: '#f8f9fa' }}>
                <Typography variant="body1" style={{ color: '#1976d2', marginBottom: '15px' }}>
                  {this.props.t('text_statistics')}
                </Typography>
                <div style={{padding: '15px 0px'}}>
                  <Statistics inline={true}/>
                </div>
              </Paper>
            </Grid>
          </Grid>
        </Page>
      </>
    );
  }
}

export default withTranslation()(CreateSticker);